import {apiUrl,API_ORIGEM} from './apiAmbiente';
import axios from 'axios';
import {CHAVE_SESSAO, suporteDaSessao} from './sessaoUsuario';

export const API_SUPORTE=apiUrl('AcessoSuporte.php');

export async function solicitarAcessoSuporte(idusuario,motivo,aba) {
  let tokenEmitido='';
  try {
    const dados=new FormData();dados.set('operacao_suporte','iniciar');
    dados.set('token',sessionStorage.getItem(CHAVE_SESSAO)||'');
    dados.set('idusuario',String(idusuario));dados.set('motivo',motivo);
    const {data}=await axios.post(API_SUPORTE,dados);
    if (!data?.ok || !data.token || !['/','/home','/prof-consulta'].includes(data.destino)) throw new Error(data?.erro||'Não foi possível abrir o acesso de suporte.');
    tokenEmitido=data.token;
    if (!aba || aba.closed) throw new Error('A aba de suporte foi fechada.');
    // sessionStorage pertence à nova aba; a sessão do administrador permanece.
    aba.sessionStorage.setItem(CHAVE_SESSAO,data.token);
    aba.opener=null;
    aba.location.replace(new URL(data.destino,window.location.origin).href);
    return data;
  } catch (e) {
    if (tokenEmitido) {
      const fim=new FormData();fim.set('operacao_suporte','encerrar');fim.set('suporte_token',tokenEmitido);
      try {await axios.post(API_SUPORTE,fim);} catch (_) { /* O prazo do servidor continua limitando esta sessão. */ }
    }
    if (aba && !aba.closed) aba.close();
    throw new Error(e.response?.data?.erro||e.message||'Falha ao abrir acesso de suporte.');
  }
}

export async function encerrarAcessoSuporte(forcarLocal=false) {
  const token=sessionStorage.getItem(CHAVE_SESSAO);
  try {
    if (suporteDaSessao() && token) {
      const dados=new FormData();dados.set('operacao_suporte','encerrar');dados.set('suporte_token',token);
      const {data}=await axios.post(API_SUPORTE,dados);
      if (!data?.ok) throw new Error(data?.erro||'Não foi possível encerrar o acesso.');
    }
  } catch (e) {if (!forcarLocal) throw new Error(e.response?.data?.erro||e.message||'Falha ao encerrar acesso.');}
  sessionStorage.removeItem(CHAVE_SESSAO);
  window.close();
  if (!window.closed) window.location.replace('/login');
}

export function instalarInterceptorSuporte() {
  if (axios.__mbgpSuporteInstalado) return;
  axios.__mbgpSuporteInstalado=true;
  axios.interceptors.request.use(config=>{
    const suporte=suporteDaSessao();
    if (!suporte) return config;
    const url=new URL(config.url,window.location.origin);
    if (url.origin!==API_ORIGEM || url.pathname==='/AcessoSuporte.php') return config;
    if (Number(suporte.exp)*1000<=Date.now()) return Promise.reject(new Error('Acesso de suporte expirado.'));
    const dados=new FormData();
    if (config.data instanceof FormData) {
      for (const [chave,valor] of config.data.entries()) {
        if (typeof valor!=='string') throw new Error('Este envio não está disponível no acesso de suporte.');
        dados.append(chave,valor);
      }
    } else if (config.data && typeof config.data==='object') {
      Object.entries(config.data).forEach(([chave,valor])=>dados.set(chave,String(valor)));
    } else if (config.data) throw new Error('Formato de consulta não disponível no acesso de suporte.');
    url.searchParams.forEach((valor,chave)=>{if(!dados.has(chave))dados.set(chave,valor);});
    dados.set('operacao_suporte','executar');dados.set('endpoint',url.pathname.split('/').pop());
    dados.set('suporte_token',sessionStorage.getItem(CHAVE_SESSAO)||'');
    config.url=API_SUPORTE;config.method='post';config.data=dados;config.params=undefined;
    config.__mbgpSuporte=true;
    return config;
  });
  axios.interceptors.response.use(response=>response,error=>{
    if (error.config?.__mbgpSuporte && error.response?.status===401) {
      sessionStorage.removeItem(CHAVE_SESSAO);window.location.replace('/login');
    }
    return Promise.reject(error);
  });
}

instalarInterceptorSuporte();
